import { useState, useEffect} from "react";
import Carousel from "react-bootstrap/Carousel"
import imagen1 from './img/anuncios/hmac_santa_fe_13.jpg';
import imagen2 from './img/anuncios/hmac_santa_fe_15.jpg';
import imagen3 from './img/anuncios/hmac_santa_fe_18.jpg';

const Anuncios = () => {
    return(
        <Carousel>
            <Carousel.Item>
                <div 
                    className="d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: '#f8f9fa' }}
                >
                    <img
                        width="40%"
                        src={imagen1}
                        alt="First slide"
                    />
                </div>
            </Carousel.Item>
            <Carousel.Item>
                <div 
                    className="d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: '#f8f9fa' }}
                >
                    <img
                        width="40%"
                        src={imagen2}
                        alt="First slide"
                    />
                </div>
            </Carousel.Item>
            <Carousel.Item>
                <div 
                    className="d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: '#f8f9fa' }}
                >
                    <img
                        width="40%"
                        src={imagen3}
                        alt="First slide"
                    />
                </div>
            </Carousel.Item>
        </Carousel>
    )
}

export default Anuncios;